export default "__VITE_ASSET__DMBPspFl__"